import { User } from './user.entity'

export class AdminActivity {

    description!: string
    created!: number
    user!: User

}